export const STATIC_IDS = {
  PRODUCT_DETAIL: {
    REVIEWS: 'reviews',
  },
};
